<template>
  <router-view />
  <TNToaster
    :class="['toaster', { bottom: isMobile }]"
    :toast-list="toasts"
    @closeToast="closeToast"
  />
  <Sprite v-show="false" />
</template>

<script>
import { mapMutations } from "vuex";
import useNotification from "@/composables/useNotification";
import { setDarkTheme } from "@life_uikit/uikit/helpers";
import LifeBridge from "@tnlife/tn-bridge";
import Sprite from "@/components/sprite.vue";
export default {
  name: "HomeView",
  components: {
    Sprite
  },
  setup() {
    const { toasts, closeToast } = useNotification();
    return { toasts, closeToast };
  },
  created() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
    LifeBridge.addEventListener("colorSchemeUpdated", setDarkTheme); // TODO: добавить обновление в store isDarkTheme
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapMutations(["setMobileVersion"]),
    onResize() {
      this.setMobileVersion(window.innerWidth <= 760);
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: "Proxima Nova";
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--content-primary-a-enabled);
  background: var(--background-secondary-a-enabled);
  min-height: 100%;
  @media (max-width: 760px) {
    background: var(--background-primary-a-enabled);
  }
}
.toaster {
  z-index: 999999 !important;
  top: 80px;
  &.bottom {
    bottom: 53px;
    top: auto;
  }
}
.error-mode {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}
.error-header {
  text-align: center;
  font-weight: 800;
  font-size: 2.5rem;
  opacity: 0.3;
  margin: 1rem;
}

.error-description {
  text-align: center;
  margin: 0 1rem;
}

.body-loading {
  position: relative;
  min-height: 100vh;
}

.body-loading::after {
  content: "";
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 1000;
  background-image: url("~@/assets/images/icons/loader-small-red.svg");
  background-position: center;
  background-repeat: no-repeat;
}
.selected {
  fill: var(--background-blue-hovered) !important;
}
</style>
